/**
 * KsaOverviewView - "GLOBAL KSA Overview": the Opportunities and Projects tabs
 * again, on one screen, for KSA work, on records of their own.
 *
 * The screens are the real ones (components/ksa/KsaPage), so adding, editing,
 * Won/Lost, the after-win PO form, Won moving a record to Projects, close/
 * reopen, flags, tasks, comments and the Doc Hub all behave as they do on the
 * main tabs. The records are not: they live in ksa_* tables (files in
 * uploads/ksa) behind the KSA API (server/routes/ksa.js) and never
 * reach the main tabs, Dashboard, Reporting, finance or the AI chat.
 *
 * Admin + operations by role (the 'ksa' area in src/data/roles.js), or anyone
 * given the area in the Team page; the server refuses everyone else. The check below
 * also stops a deep link from anyone else mounting the provider (and firing a
 * request) before the App.jsx guard - an effect, so it runs after this
 * renders - redirects them.
 */
import { canSeeTab } from '../data/roles';
import { useMyAccess } from '../hooks/useMyAccess';
import KsaDataProvider from '../components/ksa/KsaDataProvider';
import KsaPage from '../components/ksa/KsaPage';

export default function KsaOverviewView() {
  const access = useMyAccess();
  if (!canSeeTab(access, 'ksa-overview')) return null;
  return (
    <KsaDataProvider>
      <KsaPage />
    </KsaDataProvider>
  );
}
